import { styled } from '@mui/material';

export const PlanDisclaimerWrapperStyled = styled('div')({
  border: '1px solid #BBC1D0',
  borderRadius: '4px',
  background: '#FFFFFF',
  padding: '24px 24px 36px 24px',
  ul: {
    listStyleType: 'disc',
    paddingLeft: '30px',
  },
});
